import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./PartnerCarousel.css";

const Partner = () => {
  return (
    <section className="bg-partners">
      <div className="container">
        <h4 className="text-center text-white mb-5 fw-bold display-6">
          Our Trusted Lending Partners
        </h4>

        <div
          id="bankLogoCarouselhome"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="logo-slide-wrapper">
                <div className="logo-card">
                  <a href="https://homeloans.sbi/">
                    <img
                      src="/images/Bank Logos/sbibank.png"
                      alt="SBI"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.iob.in/home-loans.aspx">
                    <img
                      src="/images/Bank Logos/indiaoverseasbank.png"
                      alt="IOB"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://shorturl.at/hnkdg">
                    <img
                      src="/images/Bank Logos/icicibank.png"
                      alt="ICICI"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="logo-slide-wrapper">
                <div className="logo-card">
                  <a href="https://www.hdfc.com/housing-loans/home-loans">
                    <img
                      src="/images/Bank Logos/hdfcbank.png"
                      alt="HDFC"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://bankofindia.co.in/home-loan">
                    <img
                      src="/images/Bank Logos/bankofindia.png"
                      alt="Bank Of India"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.idbibank.in/home-loan.aspx">
                    <img
                      src="/images/Bank Logos/idbibank.png"
                      alt="IDBI"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="logo-slide-wrapper">
                <div className="logo-card">
                  <a href="https://www.bankofbaroda.in/personal-banking/loans/home-loan">
                    <img
                      src="/images/Bank Logos/bankofbarodha.png"
                      alt="BOB"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.centralbankofindia.co.in/en/housing-loan">
                    <img
                      src="/images/Bank Logos/centralbankofindia.png"
                      alt="CBI"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://bankofmaharashtra.in/personal-banking/loans/home-loan">
                    <img
                      src="/images/Bank Logos/bankofmaharashtra.png"
                      alt="BOM"
                    />
                  </a>
                </div>
              </div>
            </div>

            {/* Slide 4 */}
            <div className="carousel-item">
              <div className="logo-slide-wrapper">
                <div className="logo-card">
                  <a href="https://bandhanbank.com/personal/home-loan">
                    <img
                      src="https://mortbuzz.in/wp-content/uploads/2025/01/pngwing.com-3.png"
                      alt="Bandhan"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.sc.com/in/loans/home-property-loans/home-loans/">
                    <img
                      src="https://mortbuzz.in/wp-content/uploads/2025/01/pngwing.com_.png"
                      alt="Standard Chartered"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.kotak.com/en/personal-banking/loans/home-loan.html">
                    <img
                      src="https://mortbuzz.in/wp-content/uploads/2025/01/Kotak_Mahindra_Bank_logo.png"
                      alt="Kotak"
                    />
                  </a>
                </div>
                <div className="logo-card">
                  <a href="https://www.indusind.com/in/en/personal/loans/home-loan.html">
                    <img
                      src="https://mortbuzz.in/wp-content/uploads/2025/01/Indusind-Bank.png"
                      alt="IndusInd"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#bankLogoCarouselhome"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon bg-dark rounded-circle"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#bankLogoCarouselhome"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon bg-dark rounded-circle"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Partner;
